import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

import { bundleSources, createBundleLoader, LOCAL_BUNDLES } from "./i18nBundleLoader";
import { STORAGE_KEYS } from "./library/shared";
import { urlFormat } from "./library/utils";
import { buildYupLocale } from "./validation";

const defaultLanguage = "en-GB";

/**
 * Where `{{lng}}.json` is read from, in order: the bundle Glossa publishes for project `hbh`
 * (`REACT_APP_I18N_BASE_URL`, e.g. https://glsdwesa.blob.core.windows.net/locales/hbh), the legacy
 * Phrase blob (`REACT_APP_PHRASE_BASE_URL`), then the copy in `public/locales`. Unset variables
 * are skipped; locally only `public/locales` remains.
 */
const bundleBaseUrls = bundleSources(
  urlFormat(process.env.REACT_APP_I18N_BASE_URL || ""),
  urlFormat(process.env.REACT_APP_PHRASE_BASE_URL || ""),
  LOCAL_BUNDLES
);

const languageDetector = {
  type: "languageDetector" as any, // Exact type is 'backend' | 'logger' | 'languageDetector' | 'postProcessor' | 'i18nFormat' | '3rdParty'
  async: true, // flags below detection to be async
  detect: (callback) => {
    const lng = localStorage.getItem(STORAGE_KEYS.appLang);

    // console.log(lng, "lng here");
    // return callback(JSON.parse(lng) || defaultLanguage);

    const parsedLng = lng ? JSON.parse(lng) : "";

    return callback(parsedLng || defaultLanguage);
  },
  init: () => {},
  cacheUserLanguage: () => {},
};
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(Backend)
  .use(languageDetector)
  .init(
    {
      keySeparator: false,
      interpolation: {
        escapeValue: false,
      },
      load: "currentOnly",
      backend: {
        // for all available options read the backend's repository readme file
        loadPath: `${bundleBaseUrls[0]}/{{lng}}.json`,
        request: createBundleLoader(bundleBaseUrls),
      },
      fallbackLng: (code: string) => {
        if (!code || code === "en-US") return ["en-GB", "de-AT"];

        if (code === "de-DE") return ["de-AT", "en-GB"];
        if (code === "de-CH") return ["de-AT", "en-GB"];
        if (code === "de-AT") return ["de-AT", "en-GB"];

        return ["en-GB", "de-AT"];
      },
      saveMissing: true,

      missingKeyHandler: (lngs, _, key, fallbackValue) => {
        // Check if the key is available in 'en-GB', and if so, return its value

        if (lngs[1] === "en-GB") {
          return i18n.t(key, { lng: "en-GB" });
        }

        // If not found in 'en-GB', return the fallback value
        console.warn(`Missing translation key: ${key}`);
        return fallbackValue;
      },
      supportedLngs: [
        "en-GB",
        "de-AT",
        "bg-BG",
        "cs-CZ",
        "et-EE",
        "hr-HR",
        "hu-HU",
        "lt-LT",
        "pl-PL",
        "ro-RO",
        "ru-RU",
        "sr-Latn-RS",
        "sk-SK",
        "sl-SI",
        "tr-TR",
        "uk-UA",
      ],
      postProcess: ["phraseInContextEditor"],
    },
    buildYupLocale
  );

export default i18n;
(window as any).i18n = i18n;
